export interface IAppUser {
  id: string;
  firstname: string;
  lastname: string;
  fullname: string;
  email: string;
  roles: UserRole[];
}

export enum UserRole {
  PMEDataIntegrity = 'PME - Data Integrity',
  PMEPartContributor = 'PME - Part Contributor'
}
